import React, { FC, useCallback } from 'react';

import { TabsContainer, TabsMenu, TabsMenuItem, TabsPanel } from '@portal/common/components';
import { styled } from '@portal/common/theme';

import _ from '../../locale';

export const DENGUE_SCENARIOS_TABS_CONFIG = ['about', 'explorer'];

const Container = styled('div')(({ theme }) => ({
    zIndex: theme.zIndex.pageHeader,
    position: 'absolute',
    top: 100,
    left: 0,
    width: '100%',
    paddingLeft: 30,
    paddingRight: 30,
    background: theme.color.white,
}));

type Props = {
    activeTabIndex: number;
    setActiveTabIndex: (index: number) => void;
};

const DengueScenariosTabSelector: FC<Props> = ({ activeTabIndex, setActiveTabIndex }) => {
    const handleTabChange = useCallback(
        (index: number) => {
            setActiveTabIndex(index);
        },
        [setActiveTabIndex]
    );

    return (
        <Container>
            <TabsContainer selectedIndex={activeTabIndex} onSelect={handleTabChange}>
                <TabsMenu>
                    {DENGUE_SCENARIOS_TABS_CONFIG.map((tab) => (
                        <TabsMenuItem key={tab}>{_(`dengue_scenarios_${tab}_tab`)}</TabsMenuItem>
                    ))}
                </TabsMenu>
                <TabsPanel />
                <TabsPanel />
            </TabsContainer>
        </Container>
    );
};

export default DengueScenariosTabSelector;
